import { ScheduleType } from "../../../../../../shared/src/data/scheduleType";

export const RegionOfInterestColors = {
    [ScheduleType.Door]: '#4A90E2',            // Soft Blue
    [ScheduleType.LightingFixture]: '#7ED321', // Soft Green
    [ScheduleType.MechanicalFixture]: '#9B59B6', // Soft Purple
    [ScheduleType.PlumbingFixture]: '#E67E22', // Soft Orange
    [ScheduleType.RoomFinish]: '#F1C40F',      // Soft Yellow
    [ScheduleType.RoomName]: '#34495E',        // Dark Gray
    [ScheduleType.SheetIndex]: '#D35400',     // Soft Brown
    [ScheduleType.Wall]: '#E74C3C',            // Soft Red
    [ScheduleType.Window]: '#F39C12',          // Soft Gold
  }